import React from "react";

import Divider from "@/components/Atoms/Divider";

import theme from "@/foundation/Theme";

import { PageTitleWrapper, StyledPageTitle } from "./style";

const PageTitle = ({ title, ...rest }) => (
  <PageTitleWrapper>
    <Divider
      color={theme.colorsV2.blue.shade_700}
      margin="0px"
      height="0px"
      borderWidth="4px"
      variant="VERTICAL"
      style={{ borderRadius: "8px" }}
    />
    <StyledPageTitle variant="heading4" {...rest}>
      {title}
    </StyledPageTitle>
  </PageTitleWrapper>
);

export default PageTitle;
